import { Attributes } from '~/components/Product/types/product';
import type { Maybe, PaymentInfo } from '~/types/GraphQL';

export default {
  attributesForPayment: () => [
    Attributes.BRAND,
    Attributes.HAZARD_NOTICE,
    Attributes.ENERGY_EFFICIENCY_LABEL,
    Attributes.ENERGY_EFFICIENCY_CLASS,
    Attributes.DANGER_ICONS,
    Attributes.SEALS,
    Attributes.DETAIL_NAME,
    Attributes.SIGNAL_WORD,
    Attributes.MANUFACTURER_INFOS,
    Attributes.CAPACITY_UOM,
    Attributes.CAPACITY_QUANTITY,
    Attributes.MATERIAL,
    Attributes.COLOR,
    Attributes.SIZE,
    Attributes.SIZE_ORDER,
    Attributes.COLOR_CODE,
    Attributes.DISCOUNT_SALE_VALUE,
  ],
  getActivePaymentMethod: (paymentInfo: Maybe<PaymentInfo | undefined>) => paymentInfo?.payments?.find(payment => payment.custom?.customFieldsRaw?.some(field => field.name === 'isActive' && field.value === true)),
};
